import axios from 'axios';
import React,{ useState,useEffect,useRef } from 'react';

function ChatCard(props) {    
    const [messages, setMessages] = useState([])
    const [forUseEffect, setForUseEffect] = useState(false);
    const [date, setDate] = useState("");
    const [lastMessage, setLastMessage] = useState(null);
    const [sender, setSender] = useState("");
    const chatCard = useRef();

function sendData(roomId){
    roomId=roomId.toString();
   
    props.socket.emit("join_room",roomId);
    localStorage.setItem("roomId", roomId);
     props.setRightDisplay({
         image:props.image,
         firstname:props.firstname,
         email:props.email,
         room:roomId,
         showRight:true, 
     })
}

useEffect(() => {
    axios.get("https://newchatapp-mn65.onrender.com/getmessages", {
        headers: {
            Authorization: 'Bearer ' + props.token
        }
    }).then((res) => {
        var n=0;
        res.data.forEach( message=>{
            if(message.senderMail===props.email){
                  if(n==0){
                   setDate(message.date);
                   setLastMessage(message.body);
                   if(message.sender) setSender(message.sender)
                   n=n+1;
                  }
            }
        })
    })
}, [])


    
useEffect(() => {
    if(forUseEffect){
        if(messages.length !==0){
            var roomId=Math.floor(Math.random() * 100000);
            var n=0;
             messages.forEach( message=>{
                 if(message.senderMail===props.email){
                       roomId=message.roomId;
                       if(n==0){
                        setDate(message.date);
                        setLastMessage(message.body);
                        if(message.sender) setSender(message.sender)
                        n=n+1;
                       }
                         props.setCurrMessages((prev)=>{
                             return(
                                 [...prev,message ]
                             )
                         })
                    
                 }
             })
            
             sendData(roomId);
            
         }else{
             var RoomId = Math.floor(Math.random() * 100000);
             RoomId=RoomId.toString();
             sendData(RoomId)
         }   
         const input = document.querySelector(".chatTypeInput");
         if(input!==null) input.focus();
    }else{
        setForUseEffect(true);
    }
}, [messages])           
                      
   

function handleClick(e){
    
    
    var lc = localStorage.getItem("roomId");
    if(lc){
        props.socket.emit('forceDisconnect',lc);
    }
    props.setCurrMessages([]);
     axios.get("https://newchatapp-mn65.onrender.com/getmessages", {
        headers: {
            Authorization: 'Bearer ' + props.token
        }
    }).then((res) => {
        setMessages(res.data);
    })

       
        document.querySelectorAll(".check").forEach(data=>{
            data.classList.remove("selectedUser");
        })
        // console.log(chatCard.current);
        chatCard.current.classList.add("selectedUser");
    }

    return (
        <div  className="chatcard ">
        <div ref={chatCard}  onClick={handleClick} className="check"></div>
            <div onClick={handleClick}  className="userchatcard">
                <img draggable="false" className='chatprofile homeprofilepic' src={props.image} alt="" />
                <div className="userchatcardinfo">
                    <h3>{ props.firstname}</h3>
                    <p>{!props.lstMessage &&(sender===""?null:sender+" : ")}  {(props.lstMessage&&(props.lstMessage.length>20?(props.lstMessage.substr(0,19)+"..."):props.lstMessage)) || (lastMessage && (lastMessage.length>20?(lastMessage.substr(0,19)+"..."):lastMessage)) }</p>
                </div>
                {props.email==="RITESHHAJARE7@GMAIL.COM" && <i title='Verified' className="verified fa-solid fa-circle-check"></i>}
                <small>{date!=="" && date}</small>
            </div>
            <hr className='hrcard' />
        </div>

    )
}

export default ChatCard